"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _Table = _interopRequireDefault(require("@material-ui/core/Table"));

var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));

var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));

var _TableContainer = _interopRequireDefault(require("@material-ui/core/TableContainer"));

var _TableHead = _interopRequireDefault(require("@material-ui/core/TableHead"));

var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../constants");

var _Button = _interopRequireDefault(require("../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledTableCell = (0, _styles.withStyles)(() => ({
  head: {
    backgroundColor: _constants.colours.backgroundDisabled,
    height: 60,
    padding: '0 24px 0 21px',
    borderBottom: 0,
    fontWeight: 'bold'
  },
  body: {
    fontSize: _constants.fontSizes.detail3,
    paddingLeft: 21,
    borderBottom: 0,
    position: 'relative',
    color: _constants.colours.font,
    '&.text-bold': {
      fontWeight: 'bold'
    },
    '&:not(:last-child)': {
      '& .separator': {
        position: 'absolute',
        display: 'block',
        height: '100%',
        background: _constants.colours.backgroundDisabled,
        width: 1,
        right: 0,
        top: 0
      }
    },
    '& button.noShadow': {
      boxShadow: 'none'
    }
  }
}))(_TableCell.default);
const StyledTableRow = (0, _styles.withStyles)(() => ({
  root: {
    height: 50,
    '&:nth-of-type(even)': {
      backgroundColor: _constants.colours.activeFilterBar
    },
    '&:hover': {
      transform: 'scale(1)',
      backgroundColor: _constants.colours.white,
      cursor: 'pointer',
      boxShadow: _constants.shadows.tableRowHover,
      '& td': {
        '&:first-child': {
          '&:before': {
            position: 'absolute',
            content: '""',
            display: 'block',
            width: 4,
            height: '100%',
            backgroundColor: _constants.colours.primary,
            left: 0,
            top: 0
          }
        },
        '& .separator': {
          display: 'none'
        }
      }
    }
  }
}))(_TableRow.default);
const StyledTableContainer = (0, _styles.withStyles)(() => ({
  root: {
    overflow: 'visible'
  }
}))(_TableContainer.default);
const useStyles = (0, _styles.makeStyles)({
  table: {
    minWidth: 700,
    '& .action-btn': {
      marginLeft: 10,
      minWidth: 100
    },
    '& .action-btn:first-of-type': {
      marginLeft: 0
    }
  }
});

const getActionsButtons = (column, row) => {
  return column.buttons.map(button => {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      style: button.style,
      key: button.text,
      variant: button.variant,
      type: "button",
      className: `action-btn ${button.classes}`,
      onClick: () => {
        button.clickHandler(row);
      },
      customPalette: button.customPalette
    }, button.text);
  });
};

const CustomizedTables = ({
  columns,
  rows
}) => {
  const classes = useStyles();

  const getColumnTemplate = (column, row) => {
    const templateProps = { ...column.template.props
    };

    if (column.templateOnChange) {
      templateProps.onChange = (e, newValue) => column.templateOnChange(newValue, row, column);
    }

    if (column.templateValue) {
      templateProps[column.templateValue] = row[column.name];
    }

    return { ...column.template,
      props: templateProps
    };
  };

  const getCellContents = (column, row) => {
    if (column.template) {
      return getColumnTemplate(column, row);
    }

    if (column.name !== 'actions') {
      return row[column.name];
    }

    return getActionsButtons(column, row);
  };

  return /*#__PURE__*/_react.default.createElement(StyledTableContainer, {
    component: _Paper.default,
    elevation: 0,
    square: true
  }, /*#__PURE__*/_react.default.createElement(_Table.default, {
    stickyHeader: true,
    size: "small",
    className: classes.table,
    "aria-label": "customized table"
  }, /*#__PURE__*/_react.default.createElement(_TableHead.default, null, /*#__PURE__*/_react.default.createElement(_TableRow.default, {
    role: "rowheader"
  }, columns.map(column => /*#__PURE__*/_react.default.createElement(StyledTableCell, {
    role: "columnheader",
    align: column.align || 'left',
    style: column.headerStyle,
    key: column.name
  }, column.label)))), /*#__PURE__*/_react.default.createElement(_TableBody.default, null, rows.map(row => /*#__PURE__*/_react.default.createElement(StyledTableRow, {
    role: "row",
    key: row.id
  }, columns.map(column => /*#__PURE__*/_react.default.createElement(StyledTableCell, {
    role: "cell",
    style: column.style,
    align: column.align || 'left',
    key: `${column.name}-${row.id}`
  }, getCellContents(column, row), /*#__PURE__*/_react.default.createElement("span", {
    className: "separator"
  }))))))));
};

CustomizedTables.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    label: _propTypes.default.string,
    headerStyle: _propTypes.default.oneOfType([_propTypes.default.object]),
    style: _propTypes.default.oneOfType([_propTypes.default.object]),
    align: _propTypes.default.string,
    buttons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object])),
    template: _propTypes.default.node,
    templateValue: _propTypes.default.string,
    templateOnChange: _propTypes.default.func,
    width: _propTypes.default.number,
    minWidth: _propTypes.default.number,
    classes: _propTypes.default.string
  })).isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object])).isRequired
};
var _default = CustomizedTables;
exports.default = _default;